<template>
  <section class="text-center">
    <h3 class="text-4xl m-6">My Shopping Bill Separator</h3>
    <h4 class="text-3xl m-10">รวม {{ total }} บาท</h4>
    <div class="list mx-0 my-6 md:m-10">
      <h4 class="mb-2 text-2xl">First bill {{ firstChunkTarget }}</h4>
      <table
        class="table-auto w-full bg-teal-lightest border-grey-darker border-solid"
      >
        <thead class="bg-teal-light">
          <tr class="p-2">
            <th class="p-2">Product</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Total</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in firstChunk" :key="product.id" class="p-2">
            <td>{{ product.prefer == 1 ? '*' : '' }}{{ product.name }}</td>
            <td>{{ product.price }}</td>
            <td class="p-2">{{ product.quantity }}</td>
            <td>{{ productPrice(product) }}</td>
            <td>
              <button
                @click="selectEdit(product)"
                class="bg-blue hover:bg-blue-dark text-white font-bold py-1 px-2 md:py-2 md:px-4 md:mr-2 rounded focus:outline-none focus:shadow-outline"
              >
                <i class="icon-pencil"></i>
              </button>
              <button
                @click="deleteItem(product.id)"
                class="bg-red hover:bg-red-dark text-white font-bold py-1 px-2 md:py-2 md:px-4 rounded focus:outline-none focus:shadow-outline"
              >
                <i class="icon-trash"></i>
              </button>
            </td>
          </tr>
          <tr class="font-bold">
            <td colspan="3" class="text-right p-2">Total:</td>
            <td>{{ totalFirst }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="list mx-0 my-6 md:m-10">
      <h4 class="mb-2 text-2xl">Second bill {{ secondChunkTarget }}</h4>
      <table
        class="table-auto w-full bg-purple-lightest border-grey-darker border-solid"
      >
        <thead class="bg-purple-light">
          <tr class="p-2">
            <th class="p-2">Product</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Total</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in secondChunk" :key="product.id" class="p-2">
            <td>{{ product.prefer == 2 ? '*' : '' }}{{ product.name }}</td>
            <td>{{ product.price }}</td>
            <td class="p-2">{{ product.quantity }}</td>
            <td>{{ productPrice(product) }}</td>
            <td>
              <button
                @click="selectEdit(product)"
                class="bg-blue hover:bg-blue-dark text-white font-bold py-1 px-2 md:py-2 md:px-4 md:mr-2 rounded focus:outline-none focus:shadow-outline"
              >
                <i class="icon-pencil"></i>
              </button>
              <button
                @click="deleteItem(product.id)"
                class="bg-red hover:bg-red-dark text-white font-bold py-1 px-2 md:py-2 md:px-4 rounded focus:outline-none focus:shadow-outline"
              >
                <i class="icon-trash"></i>
              </button>
            </td>
          </tr>
          <tr class="font-bold">
            <td colspan="3" class="text-right p-2">Total:</td>
            <td>{{ totalSecond }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-show="mode == 'add'"
      class="mb-2 flex flex-col justify-center items-center"
    >
      <h5 class="mb-6">Add new item</h5>
      <form action="" @submit.prevent="addItem" class="w-full max-w-md">
        <div class="flex flex-wrap -mx-3 mb-6 p-2 md:p-0">
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-6">
            <input
              type="text"
              name="name"
              id="addName"
              value=""
              placeholder="name"
              v-model="addName"
              class="shadow appearance-none block w-full border rounded py-2 px-3 mr-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <input
              type="number"
              name="price"
              v-model.number="addPrice"
              placeholder="price"
              class="shadow appearance-none border w-full rounded py-2 px-3 mr-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-6">
            <input
              type="number"
              name="quantity"
              v-model.number="addQuantity"
              placeholder="quantity"
              value="1"
              class="shadow appearance-none border w-full rounded py-2 px-3 mr-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4">
            <!--<label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="add_prefer">-->
            <!--State-->
            <!--</label>-->
            <div class="relative">
              <select
                v-model="addPrefer"
                class="shadow block appearance-none w-full border text-grey-darker py-2 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey"
                id="add_prefer"
              >
                <option value="0">None</option>
                <option value="1">First</option>
                <option value="2">Second</option>
              </select>
              <div
                class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="w-full px-3 mb-4 md:mb-0">
            <div class="alert mb-2" v-show="error">
              <p class="text-red text-xs italic">
                Please enter quantity and price.
              </p>
            </div>
            <button
              type="submit"
              class="bg-blue hover:bg-blue-dark w-full text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Add
            </button>
          </div>
        </div>
      </form>
    </div>
    <div
      class="mb-2 flex flex-col justify-center items-center"
      v-show="mode == 'edit'"
    >
      <h5 class="mb-6">Edit: {{ editName }}</h5>
      <form action="" @submit.prevent="editItem" class="w-full max-w-md">
        <input type="hidden" v-model="editId" />
        <div class="flex flex-wrap -mx-3 mb-6 p-2 md:p-0">
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-6">
            <input
              type="text"
              name="name"
              id="editName"
              value=""
              placeholder="name"
              v-model="editName"
              class="shadow appearance-none border w-full rounded py-2 px-3 mr-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-6">
            <input
              type="number"
              name="price"
              v-model.number="editPrice"
              placeholder="price"
              class="shadow appearance-none border w-full rounded py-2 px-3 mr-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-6">
            <input
              type="number"
              name="quantity"
              v-model.number="editQuantity"
              placeholder="quantity"
              value="1"
              class="shadow appearance-none border w-full rounded py-2 px-3 mr-2 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-6">
            <!--<label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="edit_prefer">-->
            <!--State-->
            <!--</label>-->
            <div class="relative">
              <select
                v-model="editPrefer"
                class="shadow block appearance-none w-full border text-grey-darker py-2 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey"
                id="edit_prefer"
              >
                <option value="0">None</option>
                <option value="1">First</option>
                <option value="2">Second</option>
              </select>
              <div
                class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="w-full">
            <div class="alert mb-2" v-show="editError">
              <p class="text-red text-xs italic">
                Please enter quantity and price.
              </p>
            </div>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <button
              type="submit"
              class="bg-blue hover:bg-blue-dark w-full text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Edit
            </button>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <button
              type="button"
              @click="cancelEdit"
              class="bg-red hover:bg-red-dark w-full text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
    <div
      class="setting mb-8 flex flex-col justify-center items-center bg-grey-lightest pt-6"
    >
      <div class="w-full flex flex-wrap p-2 max-w-md">
        <div class="mb-4 md:mb-6 w-full md:w-1/2">
          <label for="setting_first_chunk" class="mr-2"
            >First bill target</label
          >
          <input
            type="number"
            id="setting_first_chunk"
            name="first_chunk"
            v-model.number="firstChunkTarget"
            v-on:input="saveSettingsToLocalStorage"
            class="shadow appearance-none border rounded py-2 px-3 mr-5 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div class="mb-4 md:mb-6 w-full md:w-1/2">
          <label for="setting_second_chunk" class="mr-2"
            >Second bill target</label
          >
          <input
            type="number"
            id="setting_second_chunk"
            name="first_chunk"
            v-model.number="secondChunkTarget"
            v-on:input="saveSettingsToLocalStorage"
            class="shadow appearance-none border rounded py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div class="w-full">
          <button
            type="button"
            @click="reset"
            class="bg-purple hover:bg-purple-dark w-full text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'shopping',
  data() {
    return {
      loading: false,
      error: false,
      firstChunkTarget: 1000,
      secondChunkTarget: 300,
      items: [],
      addName: null,
      addPrice: null,
      addQuantity: 1,
      addPrefer: 0,
      editError: false,
      editId: null,
      editName: null,
      editPrice: null,
      editQuantity: 1,
      editPrefer: 0,
      mode: 'add'
    };
  },
  mounted() {
    this.loadFromLocalStorage();
    this.loadSettingsFromLocalStorage();
  },
  computed: {
    total() {
      let sum = 0;
      this.items.forEach(product => {
        sum += this.productPrice(product);
      });
      return sum;
    },
    chunksBasic() {
      let sumFirst = 0;
      let sumSecond = 0;
      let firstChunk = [];
      let secondChunk = [];
      let remainingFirst = parseInt(this.firstChunkTarget);
      let remainingSecond = parseInt(this.secondChunkTarget);
      this.items
        .slice(0)
        .filter(a => !!a.prefer)
        .forEach(product => {
          if (product.prefer == 1) {
            firstChunk.push(product);
            sumFirst = sumFirst + product.total;
            remainingFirst -= product.total;
          } else if (product.prefer == 2) {
            secondChunk.push(product);
            sumSecond = sumSecond + product.total;
            remainingSecond -= product.total;
          }
        });
      this.items
        .slice(0)
        .sort((a, b) => {
          return b.total - a.total;
        })
        .forEach(product => {
          let addToFirst = remainingFirst > remainingSecond;
          if (product.prefer == 0) {
            if (addToFirst) {
              firstChunk.push(product);
              sumFirst = sumFirst + product.total;
              remainingFirst -= product.total;
            } else {
              secondChunk.push(product);
              sumSecond = sumSecond + product.total;
              remainingSecond -= product.total;
            }
          }
        });
      return {
        first: firstChunk,
        second: secondChunk
      };
    },
    chunksBruceForce() {
      let bestFirstChunk = [];
      let bestSecondChunk = [];
      // let bestSumFirst = 0;
      // let bestSumSecond = 0;
      // let bestRemainingFirst = 0;
      // let bestRemainingSecond = 0;
      let bestDiff = 9999999;

      let baseFirstChunk = [];
      let baseSecondChunk = [];
      let baseRemainingFirst = this.firstChunkTarget;
      let baseRemainingSecond = this.secondChunkTarget;

      // console.log(this.items.length);
      if (this.items.length == 0) {
        return {
          first: [],
          second: []
        };
      }

      let items = this.items.slice(0).filter(a => a.prefer == 0);

      let possibleCombinations = Math.pow(2, items.length);
      if (items.length == 0) {
        possibleCombinations = 0;
      }

      // console.log(items);

      this.items
        .slice(0)
        .filter(a => a.prefer != 0)
        .forEach(product => {
          if (product.prefer == 1) {
            // console.log('add prefer 1');
            baseFirstChunk.push(product);
            // sumFirst = sumFirst + product.total;
            baseRemainingFirst -= product.total;
          } else {
            baseSecondChunk.push(product);
            // sumSecond = sumSecond + product.total;
            baseRemainingSecond -= product.total;
          }
        });
      // console.log('end prefer');
      // console.log(baseFirstChunk);
      // console.log(perferItems);
      // console.log("len: "+items.length);

      // console.log("count: "+items);

      let goToFirst = false;
      let tryFirst = [];
      let trySecond = [];
      // let sumTryFirst = 0;
      // let sumTrySecond = 0;
      let remainingTryFirst = 0;
      let remainingTrySecond = 0;
      let tryDiff = 0;
      // console.log("possibleCombinations: "+possibleCombinations);

      if (possibleCombinations == 0) {
        return {
          first: baseFirstChunk,
          second: baseSecondChunk
        };
      }

      for (
        let combinationIterator = 0;
        combinationIterator < possibleCombinations;
        combinationIterator++
      ) {
        // console.log(combinationIterator);
        let combinationBinary = this.dec2bin(combinationIterator, items.length);
        tryFirst = baseFirstChunk.slice(0);
        trySecond = baseSecondChunk.slice(0);
        // sumTryFirst = 0;
        // sumTrySecond = 0;
        remainingTryFirst = baseRemainingFirst;
        remainingTrySecond = baseRemainingSecond;
        // console.log(combinationBinary);

        for (let i = 0; i < combinationBinary.length; i++) {
          goToFirst = combinationBinary.charAt(i);
          if (goToFirst == '1') {
            tryFirst.push(items[i]);
            remainingTryFirst = remainingTryFirst - items[i].total;
          } else {
            trySecond.push(items[i]);
            remainingTrySecond = remainingTrySecond - items[i].total;
          }
        }

        tryDiff = Math.abs(remainingTryFirst - remainingTrySecond);
        if (tryDiff < bestDiff) {
          bestFirstChunk = tryFirst;
          bestSecondChunk = trySecond;
          bestDiff = tryDiff;
        }
      }

      return {
        first: bestFirstChunk,
        second: bestSecondChunk
      };
    },
    firstChunk() {
      return this.chunksBruceForce.first;
    },
    secondChunk() {
      return this.chunksBruceForce.second;
    },
    totalFirst() {
      let sum = 0;
      this.firstChunk.forEach(product => {
        sum += this.productPrice(product);
      });
      return sum;
    },
    totalSecond() {
      let sum = 0;
      this.secondChunk.forEach(product => {
        sum += this.productPrice(product);
      });
      return sum;
    }
  },
  methods: {
    dec2bin(dec, digit) {
      return (dec >>> 0).toString(2).padStart(digit, '0');
    },
    addItem() {
      if (!this.addPrice || this.addPrice <= 0) {
        this.error = true;
        return;
      }
      // this.items.push({
      //   name: this.addName,
      //   price: this.addPrice,
      //   quantity: this.addQuantity,
      //   prefer: this.addPrefer,
      //   total: this.addPrice * this.addQuantity,
      //   id: Math.floor(Math.random() * 100000 + 1)
      // });
      // see https://vuedose.tips/tips/1/ for more detail
      this.items = Object.freeze([
        ...this.items,
        {
          name: this.addName,
          price: this.addPrice,
          quantity: this.addQuantity,
          prefer: this.addPrefer,
          total: this.addPrice * this.addQuantity,
          id: Math.floor(Math.random() * 100000 + 1)
        }
      ]);

      this.error = false;
      this.addName = null;
      this.addPrice = null;
      this.addQuantity = 1;
      this.addPrefer = 0;

      document.getElementById('addName').focus();
      this.saveToLocalStorage();
    },
    deleteItem(id) {
      /*let index = -1;
      for (let i = 0; i < this.items.length; i += 1) {
        if (this.items[i].id === id) {
          index = i;
        }
      }
      // remove
      if (index >= 0) {
        this.items.splice(index, 1);
      }*/
      this.items = Object.freeze(
        this.items.filter(product => product.id != id)
      );

      this.saveToLocalStorage();
    },
    cancelEdit() {
      this.mode = 'add';
    },
    selectEdit(product) {
      this.editId = product.id;
      this.editName = product.name;
      this.editPrice = product.price;
      this.editQuantity = product.quantity;
      this.editPrefer = product.prefer;
      this.mode = 'edit';
    },
    editItem() {
      if (!this.editPrice || this.editPrice <= 0) {
        this.editError = true;
        return;
      }

      this.deleteItem(this.editId);

      // add updated item
      // this.items.push({
      //   name: this.editName,
      //   price: this.editPrice,
      //   quantity: this.editQuantity,
      //   total: this.editPrice * this.editQuantity,
      //   prefer: this.editPrefer,
      //   id: this.editId
      // });
      this.items = Object.freeze([
        ...this.items,
        {
          name: this.editName,
          price: this.editPrice,
          quantity: this.editQuantity,
          prefer: this.editPrefer,
          total: this.editPrice * this.editQuantity,
          id: this.editId
        }
      ]);

      this.editError = false;
      this.editName = null;
      this.editPrice = null;
      this.editQuantity = 1;
      this.editPrefer = 0;
      this.mode = 'add';

      this.saveToLocalStorage();

      document.getElementById('addName').focus();
    },
    productPrice(product) {
      return product.quantity * product.price;
    },
    reset() {
      this.items = [];
      this.saveToLocalStorage();
      this.saveSettingsToLocalStorage();
    },
    saveToLocalStorage() {
      localStorage.setItem('products', JSON.stringify(this.items));
    },
    loadFromLocalStorage() {
      const products = JSON.parse(localStorage.getItem('products'));
      if (products) {
        this.items = products;
      }
    },
    saveSettingsToLocalStorage() {
      localStorage.setItem('first_target', this.firstChunkTarget);
      localStorage.setItem('second_target', this.secondChunkTarget);
    },
    loadSettingsFromLocalStorage() {
      const first = localStorage.getItem('first_target');
      if (first) {
        this.firstChunkTarget = first;
      }
      const second = localStorage.getItem('second_target');
      if (second) {
        this.secondChunkTarget = second;
      }
    }
  }
};
</script>

<style scoped>
td:last-child {
  width: 20%;
  max-width: 200px;
}
</style>
